










































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import CursorDiagramToolbar from '@c/toolbar/CursorDiagramToolbar.vue';
import {CursorDiagramModeManager} from '@/logic/cursorDiagramModeManager';
import {CursorLabelModel} from '@/logic/cursors/labelModels/cursorLabelModel';
import {MarkerCursorLabelModel} from '@/logic/cursors/labelModels/markerCursorLabelModel';
import {spectrumDiagramModes} from '@/logic/diagramModes';
import {
  DiagramModeType,
  DiagramType,
  DiagramZoomType,
  SpectrumEventType,
  SpectrumYAxisType,
} from '@/enums/diagrams';
import {CursorDiagramState} from '@/logic/cursorDiagramState';
import diagramStoreModule from '@/store/modules/spectrumDiagramModule';
import {FindPeaksAction} from '@/logic/diagramActions/findPeaksAction';
import {
  ComparedDiagramData,
  DiagramData,
  DiagramMode,
  DiagramSettings,
  Freqband,
} from '@/interfaces/diagrams';
import {DiagramAxisProvider} from '@/logic/diagramAxisProvider';
import {spectrumColorScheme} from '@/utils/colorSchemes';
import ToolbarToogleIconButton from '@c/toolbar/ToolbarToogleIconButton.vue';
import DiagramSettingsDialog from '@/components/diagrams/nodeConfigs/DiagramSettingsDialog.vue';
import {drop} from 'lodash';
import SyncMenuButton from '@c/toolbar/SyncMenuButton.vue';
import {spectrumDiagramSyncModes} from '@c/toolbar/configurate';
import {DiagramSyncModeType} from '@/components/toolbar/enums';
import {spectrumYAxisTypes} from '@/api/configurate';
import {reverseUnitInTitle} from '@/utils/unitUtils';
import ToolbarIconButton from '@c/toolbar/ToolbarIconButton.vue';

import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';

exportingInit(Highcharts);
offlineExporting(Highcharts);

@Component({
  components: {
    highchart: Chart,
    CursorDiagramToolbar,
    ToolbarToogleIconButton,
    DiagramSettingsDialog,
    SyncMenuButton,
    ToolbarIconButton,
  },
})
export default class SpectrumDiagram extends Vue {
  //Цвет графика
  @Prop({required: true})
  color!: string;

  @Prop({required: true})
  isYLogAxis!: boolean;

  @Prop({required: true})
  hideZeroFrequency!: boolean;

  // Данные графика
  @Prop({required: true, default: {}})
  chartData!: ComparedDiagramData;

  @Prop({required: false, default: false})
  allowComparison!: boolean;

  @Prop({required: false})
  span_nodes!: any;

  @Prop({required: false})
  timestamp: any;

  //первоначальная установка цвета графика из настроек пользователя
  @Watch('color')
  onChangedColor(newval: string, oldval: string) {
    if (newval && oldval === '') this.settings = {...this.settings, matchColor: newval};
  }

  //первоначальная установка отображения логорифм оси
  @Watch('isYLogAxis')
  onChangedLogAxis(newval: boolean) {
    if (newval !== undefined) this.settings = {...this.settings, isYLogAxis: newval};
  }

  //первоначальная установка отображения логорифм оси
  @Watch('hideZeroFrequency')
  onChangedHideZeroFrequency(newval: boolean) {
    if (newval !== undefined && newval !== null)
      this.settings = {...this.settings, hideZeroFrequency: newval};
  }

  //первоначальная установка частоты из настроек пользователя
  @Watch('freqband')
  onChangedFreqband(newval: Freqband, oldval: Freqband) {
    if (newval !== undefined && newval !== null && (oldval === undefined || oldval === null))
      this.settings = {...this.settings, freqband: newval};
  }

  //Показатель живого обновления данных
  @Prop({required: false, default: true})
  propLiveUpdateStatus!: boolean;

  //Дефолтное значение для оси для графика с виброскоростью и виброускорением в вибродиагностике
  @Prop({required: false, default: undefined})
  vibrationSpectrumYAxisType!: SpectrumYAxisType;

  @Prop({required: false, type: Array, default: () => []})
  freqbands!: Freqband[];

  //Сохранённая частота
  @Prop({required: false})
  freqband!: Freqband;

  @Prop({required: false, default: ''})
  xAxisTitle!: string;

  @Prop({required: false, default: ''})
  yAxisTitle!: string;

  // Граница нулевой частоты
  zeroFrequencyBound = 1;

  @Prop({required: false, default: true})
  isYLogAxisShow?: boolean;

  //Для спектров низкой частоты в вибродиагностике получаем объект из справочника типа оси Y виброскорости/виброускорения
  get objectVibrationSpectrumYAxisType() {
    return spectrumYAxisTypes.filter(item => item.value === this.vibrationSpectrumYAxisType)[0];
  }

  // Настройки диаграммы
  settings: DiagramSettings = {
    isYLogAxisShow: this.isYLogAxisShow != null ? this.isYLogAxisShow : true,
    isYLogAxis: this.isYLogAxis,
    hideZeroFrequency:
      this.hideZeroFrequency !== undefined && this.hideZeroFrequency !== null
        ? this.hideZeroFrequency
        : this.chartData.spectrumType !== SpectrumEventType.Envelop,
    type: DiagramType.Spectrum,
    matchColor: this.color && this.color !== '' ? this.color : spectrumColorScheme[0].mainColor,
    spectrumYAxisType: this.objectVibrationSpectrumYAxisType
      ? this.objectVibrationSpectrumYAxisType
      : spectrumYAxisTypes[0],
    showSpectrumYAxisType:
      (this.chartData.spectrumType == SpectrumEventType.Low ||
        this.chartData.spectrumType == SpectrumEventType.Envelop) &&
      !this.vibrationSpectrumYAxisType,
    freqband: this.freqband,
    showFreqband:
      this.chartData.spectrumType == SpectrumEventType.Envelop && this.freqbands.length > 0,
  };

  @Watch('settings')
  onSpectrumYAxisChange(newValue: DiagramSettings, oldValue: DiagramSettings) {
    if (oldValue.spectrumYAxisType != newValue.spectrumYAxisType) {
      //TODO:Снимаем зум по Y или X-Y
      if (
        this.modeManager.zoomType !== DiagramZoomType.X &&
        this.modeManager.zoomType !== DiagramZoomType.None
      ) {
        this.$emit('changeYAxisType', {value: newValue.spectrumYAxisType?.value, recalc: false});
        this.modeManager.zoomType = DiagramZoomType.X;
        this.skipZoom();
      } else
        this.$emit('changeYAxisType', {value: newValue.spectrumYAxisType?.value, recalc: true});
    }

    if (oldValue.freqband != newValue.freqband) {
      this.$emit(
        'changeFreqband',
        this.freqbands.filter(item => item.id === newValue.freqband?.id)[0],
      );
    }
  }

  // TODO: убрать, когда информация по полям спектров будет в базе
  xUnits = 'Гц';

  // Режимы диаграммы
  diagramModes: DiagramMode[] = spectrumDiagramModes;
  // Предустановленные режимы
  preselectedModes: DiagramMode[] = [
    this.diagramModes.find(mode => mode.type === DiagramModeType.View) as DiagramMode,
  ];

  // Провайдер для работы с осями
  diagramAxisProvider: DiagramAxisProvider = new DiagramAxisProvider();

  get diagramSyncModes() {
    return spectrumDiagramSyncModes;
  }

  // Состояние кнопки обновления графика disable or enable
  get isDisabledUpdateButton() {
    const stateDiagram = this.modeManager.getState();

    const modesNeedDisableUpdate = stateDiagram.activeModes.some(mode => {
      return [DiagramModeType.Cursor, DiagramModeType.Action].includes(mode.type);
    });

    return modesNeedDisableUpdate || this.isInZoom;
  }

  get diagramStoreModule() {
    return diagramStoreModule;
  }

  // Обновлять данные на графике
  updateDiagramIndex: number | null = 0;

  get isUpdateDiagram() {
    return this.updateDiagramIndex != null; //check both null and undefined
  }

  set isUpdateDiagram(value: boolean) {
    if (value) this.updateDiagramIndex = 0;
    else this.updateDiagramIndex = null;
  }

  // Менеджер для работы с диаграммой
  modeManager: CursorDiagramModeManager = new CursorDiagramModeManager(
    DiagramType.Spectrum,
    new CursorLabelModel(this.xUnits),
    new MarkerCursorLabelModel(this.xUnits),
    this.cursorApplyCallback,
    [new FindPeaksAction()],
    (() => {
      const state = new CursorDiagramState();
      state.diagramId = this.chartData.mainDiagram.id;
      state.activeModes = this.preselectedModes;
      return state;
    })(),
  );

  setSettings(newSettings: DiagramSettings) {
    this.settings = {...newSettings};
    this.$emit('updateUserSettings', {...newSettings});
  }

  cursorApplyCallback() {
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  @Prop({required: true, default: 0})
  changedComparedCharts!: number;

  // при изменении сравниваемых графиков проверяем нужно ли скрывать настройку "логарифмическая ось Y"
  @Watch('changedComparedCharts')
  onChangedChartData() {
    const allDiagrams = [this.chartData.mainDiagram, ...this.chartData.comparedDiagrams];

    // показываем настройку "логарифмическая ось Y" только в том случае, если у нас на диграмме есть хотя бы один график, едиинцы измерения котрого не дБ
    const isYLogAxisShow =
      this.isYLogAxisShow != false && allDiagrams.some((d: DiagramData) => d.yAxis.units !== 'дБ');

    this.setSettings({...this.settings, isYLogAxisShow});
  }

  // Минимальный масштаб
  @Prop({default: 0, type: Number})
  xMinScaleValue!: number;

  // Показатель того, что применен зум
  @Prop({required: false, type: Boolean, default: false})
  isInZoom!: boolean;

  @Watch('isInZoom')
  onChangeIsInZoom(value: any) {
    if (!value) this.modeManager.clearZoom();
  }

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  @Watch('resizedKey')
  onResizedKeyChanged() {
    this.getChart().reflow();
  }

  // Идентификатор основной серии графика
  mainSeriesId = `mainSeries-${this.chartData.mainDiagram.id}`;

  // Список идентификаторов графиков на диаграмме (нужно знать для подключения курсоров)
  chartSeriesIds: string[] = [this.mainSeriesId];

  // Показатель активности тулбара для работы с графиком
  get toolbarDisabled() {
    return !this.chartData.mainDiagram.data.length;
  }

  mounted() {
    const chart = this.getChart();
    this.modeManager.init(chart, this.chartSeriesIds, this.xMinScaleValue);
  }

  addToCompare() {
    this.$emit('addToCompare');
  }

  /*
    Действия при изменении статуса отображения линии курсора
  */
  changeShowCursorLine(show: boolean) {
    //Проводим изменения для текущего графика
    this.modeManager.showLine(show);
    //Если в режиме синхронизации, то отправляем другим графикам
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Действия при изменении статуса отображения отметок курсора
  */
  changeShowCursorTooltips(show: boolean) {
    this.modeManager.showTooltips(show);
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    обновить стейт, отвечающий за "живое" обновление графиков
  */
  onUpdateButtonClick() {
    this.modeManager.updateDiagram(this.isUpdateDiagram);
    const stateDiagram = this.modeManager.getState();
    if (this.syncApply) diagramStoreModule.diagramSync(stateDiagram);
    const currentLiveUpdateStatus = this.modeManager.canLiveUpdate();
    this.$emit('liveUpdateStatusChanged', currentLiveUpdateStatus);
  }

  /*
    Выбор режима графика
  */
  selectModes(modes: DiagramMode[]) {
    const previousLiveUpdateStatus = this.modeManager.canLiveUpdate();
    this.modeManager.updateState([...modes]);
    if (this.syncApply) {
      diagramStoreModule.diagramSync(this.modeManager.getState());
    }
    //Если между предыдущим и новым состоянием произошли изменения в статусе обновления, то
    //отправляем нотификацию
    if (!this.isInZoom) this.liveUpdateStatusChangedNotify(previousLiveUpdateStatus);
  }

  /*
    Отправить уведомление об изменении состояния "живого" обновления
  */
  liveUpdateStatusChangedNotify(previousLiveUpdateStatus: boolean) {
    const newLiveUpdateStatus = this.modeManager.canLiveUpdate();
    if (previousLiveUpdateStatus !== newLiveUpdateStatus) {
      this.$emit('liveUpdateStatusChanged', newLiveUpdateStatus);
    }
  }

  /*
    Показатель применения синхронизации к графику
  */
  get syncApply() {
    return (
      this.chartData &&
      diagramStoreModule.syncModes.length &&
      diagramStoreModule.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)
    );
  }

  @Watch('modeManager.changedZoomXKey')
  onChangeZoomXKey() {
    if (this.syncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Computed поле, привязанное к vuex и watcher для него
  */
  get sync() {
    return diagramStoreModule.sync;
  }

  @Watch('sync')
  syncChanged(sync: {syncModes: any[]; syncDiagrams: any[]; syncedState: CursorDiagramState}) {
    if (!sync.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)) return;

    if (
      this.sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX) &&
      this.modeManager.zoomType !== DiagramZoomType.X &&
      this.modeManager.zoomType !== DiagramZoomType.None
    ) {
      this.modeManager.zoomType = DiagramZoomType.X;
      this.skipZoom(false);
    }

    const value = sync.syncedState;

    //проверка на то, что это не данная диаграмма
    if (value && value.diagramId === this.chartData.mainDiagram.id) {
      return;
    }
    const previousLiveUpdateStatus = this.modeManager.canLiveUpdate();
    const toolbar = this.getToolbar();

    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX)) {
      const state = new CursorDiagramState(value);
      state.diagramId = this.chartData.mainDiagram.id;
      this.modeManager.patchZoomState(state, true);

      if (value.activeModes.length === 0 && value.isUpdateDiagram) this.$emit('skipZoom');
      else if (!value.selectedZoomXData?.active) this.skipZoom(false);
      else this.$emit('zoom', value.selectedZoomXData.interval);
    }

    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.Cursors)) {
      //изменяем логику режимов
      const state = new CursorDiagramState(value);
      state.diagramId = this.chartData.mainDiagram.id;
      this.modeManager.patchCursorState(state, true);
      this.modeManager.showLine(state.isShowLine);
      this.modeManager.showTooltips(state.isShowTooltips);
      this.modeManager.updateDiagram(state.isUpdateDiagram);
    }

    const syncedState = this.modeManager.getState();
    //изменяем представление
    toolbar.setupState(syncedState);

    this.liveUpdateStatusChangedNotify(previousLiveUpdateStatus);
  }

  newComparedSeriesId(id: string) {
    return `comparedSeries-${id}`;
  }

  @Watch('chartData.spectrumType')
  updateSpectrumType(value: any, oldValue: any) {
    if (value === oldValue) return;
    const newSettings = {...this.settings};
    newSettings.showSpectrumYAxisType =
      value === SpectrumEventType.Low || value === SpectrumEventType.Envelop;
    newSettings.hideZeroFrequency = value !== SpectrumEventType.Envelop;
    newSettings.showFreqband = value === SpectrumEventType.Envelop;
    this.setSettings(newSettings);
  }

  get chartOptions() {
    const series = [];
    const that = this;

    // Убираем zeroFrequencyBound первых точек
    let mainDiagramData = this.chartData.mainDiagram.data;
    if (this.settings.hideZeroFrequency) {
      mainDiagramData = drop(mainDiagramData, this.zeroFrequencyBound);
      if (!mainDiagramData.length) this.$emit('skipZoom');
    }

    this.mainSeriesId = this.chartData.mainDiagram.id;
    this.chartSeriesIds = [this.mainSeriesId];
    series.push({
      name: this.chartData.mainDiagram.name,
      id: this.mainSeriesId,
      data: mainDiagramData,
      type: 'line',
      color: this.settings.matchColor,
      findNearestPointBy: 'xy',
      yAxis: 0,
      zIndex: this.chartData.comparedDiagrams ? this.chartData.comparedDiagrams.length : 0,
    });

    const yAxisData = this.diagramAxisProvider.getYAxis(
      this.chartData,
      spectrumColorScheme,
      this.settings.isYLogAxis,
      this.chartData.spectrumType === SpectrumEventType.Low ||
        this.chartData.spectrumType === SpectrumEventType.Envelop
        ? this.settings.spectrumYAxisType
        : undefined,
    );

    const yAxis = yAxisData.axis;

    this.chartData.comparedDiagrams.forEach((d: DiagramData, index: number) => {
      const comparedSeriesId = d.id;

      const data = this.settings.hideZeroFrequency ? drop(d.data, this.zeroFrequencyBound) : d.data;

      series.push({
        name: d.name,
        id: comparedSeriesId,
        data: data,
        type: 'line',
        color: yAxisData.comparedSeriesColors[index],
        yAxis: yAxisData.comparedSeriesAxisNumbers[index],
        zIndex: index,
      });
      this.chartSeriesIds.push(comparedSeriesId);
    });

    return {
      credits: {
        enabled: false,
      },
      title: '',
      xAxis: {
        gridLineWidth: 1,
        title: this.xAxisTitle
          ? {
              text: this.xAxisTitle,
            }
          : {text: this.xUnits != '-' ? `Частота, ${this.xUnits}` : 'Частота'},
      },
      // TODO: потом переделать заполнение наименованиями оси
      yAxis: this.yAxisTitle
        ? {
            ...yAxis,
            title: {
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              ...(yAxis.title || {}),
              text: this.yAxisTitle,
            },
          }
        : this.chartData.mainDiagram.name == 'Спектр тока'
        ? {
            title: {text: 'Амплитуда, А'},
          }
        : yAxis,
      series: series,
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          animation: {
            duration: 0,
          },
          states: {
            hover: {
              enabled: false,
              halo: {
                size: 0,
              },
              inactive: {
                enabled: false,
              },
            },
          },
          events: {
            //   legendItemClick: function(e: any) {
            //     e.preventDefault();
            //   },
            hide: function() {
              that.showOrHide();
            },
            show: function() {
              that.showOrHide();
            },
          },
        },
        line: {
          turboThreshold: 0,
          boostThreshold: 0,
          animation: {
            duration: 0,
          },
          marker: {
            enabled: false,
            radius: 0,
          },
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      chart: {
        animation: false,
        events: {
          selection: this.onSelection,
          render: this.onRender,
          afterUpdate: this.afterUpdate,
        },

        zoomType: this.modeManager.zoomType,
      },
      legend: {
        useHTML: true,
        align: 'left',
        verticalAlign: 'bottom',
        borderWidth: 0,
        enabled: true,
      },
      tooltip: {
        enabled: false,
        crosshairs: [false],
      },
    };
  }

  showOrHide() {
    const stateDiagram = this.modeManager.getState();
    const modes = stateDiagram.activeModes;
    this.modeManager.updateState([...modes]);
  }

  /*
     Действия после обновления графика - необходимо перерисовать
     все, что применено на график с режимов
     т. к. объект графика обновится
  */
  afterUpdate() {
    const state = this.modeManager.getState();

    if (this.sync && diagramStoreModule.syncedState) {
      const syncedState = new CursorDiagramState({
        ...diagramStoreModule.syncedState,
        actionData: state.actionData,
      });
      this.modeManager.updateActiveModes(syncedState, this.chartSeriesIds);
    } else this.modeManager.updateActiveModes(state, this.chartSeriesIds);
  }

  onSelection(e: any) {
    e.preventDefault();

    const dateInterval = this.modeManager.applyZoom(
      e.xAxis[0],
      e.yAxis[0],
      (
        xAxis: any,
        yAxis: any,
        chart: any,
        extremesX: any[],
        extremesY: any[],
        state: CursorDiagramState,
      ) => {
        // Применяем зум по Y
        if (yAxis) {
          chart.yAxis[0].setExtremes(yAxis.min, yAxis.max);
          extremesY.push({min: yAxis.min, max: yAxis.max});
          this.modeManager.isInYZoom = true;
        }

        // Применяем зум по X
        if (xAxis) {
          const {minIndex, maxIndex} = this.getXIndeciesByExtreme(chart, xAxis.min, xAxis.max);

          if (
            minIndex != undefined &&
            maxIndex != undefined &&
            Math.abs(minIndex - maxIndex) >= this.xMinScaleValue
          ) {
            extremesX.push({minIndex, maxIndex, min: xAxis.min, max: xAxis.max});
            state.selectedZoomXData = {
              active: true,
              interval: {startIndex: minIndex, endIndex: maxIndex},
            };
            this.modeManager.changedZoomXKey++;

            return {startIndex: minIndex, endIndex: maxIndex};
          }
        }
        return null;
      },
    );
    if (dateInterval) this.$emit('zoom', dateInterval);
  }

  getXIndeciesByExtreme(chart: any, min: any, max: any): {minIndex: any; maxIndex: any} {
    let minX = Number.MAX_VALUE;
    let maxX = -Number.MAX_VALUE;
    let minUpperP: any = null;
    let maxLowerP: any = null;

    const mainSeries = chart.get(this.mainSeriesId);

    // получаем отрезок [maxLowerP, minUpperP]
    mainSeries.points.forEach((p: any) => {
      if (p.x >= max && p.x < minX) {
        minX = p.x;
        minUpperP = p;
      }
      if (p.x <= min && p.x > maxX) {
        maxX = p.x;
        maxLowerP = p;
      }
    });

    if (maxX == -Number.MAX_VALUE) maxX = 0;

    if (minX == Number.MAX_VALUE) minX = 0;

    // d - длина отрезка [maxLowerP, minUpperP]
    const d = Math.abs(minX - maxX);

    // вычисляем коэффициенты a,b
    const a = Math.max((min - maxX) / d, 0);
    const b = Math.max((minX - max) / d, 0);

    // получаем исходные индексы отрезка [maxLowerP, minUpperP]
    const minIndex = maxLowerP?.customDataIndex ?? 0;
    const maxIndex = minUpperP?.customDataIndex ?? 0;

    // находим длину отрезка в индексах
    const dIndex = Math.abs(maxIndex - minIndex);

    // вычисляем отрезок для зума
    const leftIndex = minIndex + Math.round(dIndex * a);
    const rightIndex = maxIndex - Math.round(dIndex * b);

    if (leftIndex > rightIndex) return {minIndex: null, maxIndex: null};

    return {minIndex: leftIndex, maxIndex: rightIndex};
  }

  onRender() {
    // Некоторые действия, например отрисовку отметок на диагамме нужно делать на onRender
    // т. к. требуется перерисовка на любое изменение графика (например изменение размера)
    this.modeManager.renderActiveModes();
    const chart = this.getChart();
    if (chart && chart.resetZoomButton) chart.resetZoomButton.hide();
  }

  //Сброс зума
  skipZoom(updateState = true) {
    if (this.modeManager.skipZoom(updateState)) this.$emit('skipZoom');
  }

  //Отмена текущего зума
  undoZoom() {
    const result = this.modeManager.undoZoom(
      (chart: any, extremesX: any[], extremesY: any[], state: CursorDiagramState) => {
        if (extremesX.length > 1) extremesX.pop();
        if (extremesY.length > 1) extremesY.pop();

        if (extremesY.length === 1) this.modeManager.isInYZoom = false;

        const prevExtremesY = extremesY[extremesY.length - 1];
        const currentY = chart.yAxis[0].getExtremes();
        if (currentY.min !== prevExtremesY.min || currentY.max !== prevExtremesY.max)
          chart.yAxis[0].setExtremes(prevExtremesY.min, prevExtremesY.max);

        const prevExtremesX = extremesX[extremesX.length - 1];

        // получаем из стека индексы
        if (extremesX.length > 1) {
          state.selectedZoomXData = {
            active: true,
            interval: {startIndex: prevExtremesX.minIndex, endIndex: prevExtremesX.maxIndex},
          };
          this.modeManager.changedZoomXKey++;
          return {startIndex: prevExtremesX.minIndex, endIndex: prevExtremesX.maxIndex};
        }
        state.selectedZoomXData = {active: false};
        this.modeManager.changedZoomXKey++;
        return 'skip';
      },
    );
    if (result === 'skip') {
      this.$emit('skipZoom');
    } else if (result) {
      this.$emit('zoom', result);
    }
  }

  getChart() {
    return (this.$refs.chart as any).chart;
  }

  getToolbar() {
    return this.$refs.cursorDiagramToolbar as any;
  }

  //Сохранение картинки с графиком
  downloadChart() {
    const chart = this.getChart();

    const yAxisTitles = chart.yAxis.map((a: any) => ({
      title: {
        text: reverseUnitInTitle(a.options.title.text),
        style: {color: a.options.title.style.color},
      },
      opposite: a.opposite,
      tickPositions: a.tickPositions,
      labels: {style: {color: a.options.labels.style.color}},
    }));
    chart.exportChartLocal(
      {
        type: 'image/png',
        sourceWidth: 960,
        sourceHeight: 540,
        fallbackToExportServer: false,
      },
      {
        title:
          this.chartData.comparedDiagrams.length > 0
            ? false
            : {text: reverseUnitInTitle(this.chartData.mainDiagram.name)},
        yAxis: yAxisTitles,
      },
    );
  }
}
